import { RoleType } from '../../models/Role'
import { type CustomerSeats } from '../../store/plan/plan'
import { getRoleGroupForRoles } from './InviteRoleGroups'

export type RoleChangeSeatImpact =
  | { kind: 'unchanged' }
  | { kind: 'blocked'; seatType: RoleType; releasedSeatType: RoleType }
  | { kind: 'released'; seatType: RoleType }
  | { kind: 'notOffered' }

export const seatTypeLabels: Record<RoleType, string> = {
  [RoleType.SEAT]: 'advisor',
  [RoleType.SIDECAR]: 'assistant',
}

const availableSeats = (seats: CustomerSeats, seatType: RoleType) => (seatType === RoleType.SIDECAR ? seats.sidecar.available : seats.general.available)

interface GetRoleChangeSeatImpactArgs {
  currentRoleIds: string[]
  selectedRoleIds: string[]
  seats?: CustomerSeats
  assistantOffered: boolean
}

export const getRoleChangeSeatImpact = ({ currentRoleIds, selectedRoleIds, seats, assistantOffered }: GetRoleChangeSeatImpactArgs): RoleChangeSeatImpact => {
  const currentSeatType = getRoleGroupForRoles(currentRoleIds)?.type
  const selectedSeatType = getRoleGroupForRoles(selectedRoleIds)?.type

  if (!seats || !currentSeatType || !selectedSeatType || currentSeatType === selectedSeatType) {
    return { kind: 'unchanged' }
  }

  if (availableSeats(seats, selectedSeatType) <= 0) {
    if (selectedSeatType === RoleType.SIDECAR && !assistantOffered) {
      return { kind: 'notOffered' }
    }
    return { kind: 'blocked', seatType: selectedSeatType, releasedSeatType: currentSeatType }
  }

  return { kind: 'released', seatType: currentSeatType }
}
